import {Dialog} from '@headlessui/react';
import {noop} from '@rocket-ui/tools';
import {FC, ReactNode} from 'react';
import {RegistrationButton} from '../RegistrationButton/RegistrationButton';
import {ConfirmationQuestionIcon} from './ConfirmationQuestionIcon';
import styles from './RegistrationConfirmationModal.module.css';

type Props = {
	isOpen: boolean;
	title?: ReactNode;
	description: ReactNode;
	confirmText: ReactNode;
	onConfirm: () => void;
	onCancel?: VoidFunction;
	/** Кастомная иллюстрация справа сверху; по умолчанию — вопросительный знак. */
	illustration?: ReactNode;
};

const CloseIcon = () => (
	<svg className={styles.closeIcon} viewBox="0 0 24 24" fill="none" aria-hidden>
		<path d="M3.99805 3.99805L20.0004 20.0004" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
		<path d="M3.99805 20L20.0004 3.99768" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);

/** Модалка подтверждения в стиле регистрации ЛК (не общая ConfirmationModal). */
export const RegistrationConfirmationModal: FC<Props> = ({
	isOpen,
	title,
	description,
	confirmText,
	onConfirm,
	onCancel = noop,
	illustration,
}) => (
	<Dialog open={isOpen} onClose={onCancel} className={styles.root}>
		<div className={styles.overlay} aria-hidden="true" />

		<div className={styles.container}>
			<Dialog.Panel className={styles.panel} data-testid="registration-confirm-modal">
				<button type="button" className={styles.closeButton} onClick={onCancel} aria-label="Закрыть">
					<CloseIcon />
				</button>
				<div className={styles.illustration}>{illustration ?? <ConfirmationQuestionIcon />}</div>

				<div className={styles.body}>
					{title ? <Dialog.Title className={styles.title}>{title}</Dialog.Title> : null}
					<div className={styles.description}>{description}</div>
				</div>

				<div className={styles.footer}>
					{confirmText ? (
						<RegistrationButton variant="primary" onClick={onConfirm}>
							{confirmText}
						</RegistrationButton>
					) : null}
				</div>
			</Dialog.Panel>
		</div>
	</Dialog>
);
